import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import ProfileInfo from '../components/Provider/profile-info/ProfileInfo';
import BusinessProviderControl from '../components/Provider/business-controll/BusinessProviderControl';
import EventProviderControl from '../components/Provider/events/EventProviderControl';


const NavContainer = styled("nav")`
  display: flex;
  justify-content: center;
  padding: 30px 20px;
  background-color: transparent;
  align-items:center;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    font-size: 14px;
   
  }

  @media (max-width: 480px) {
    padding: 15px 5px;
  }
`;


const NavTabs = styled("ul")`

   display: flex;
  list-style: none;
  align-items: center;
  gap: 20px;
  padding: 0;

  & > li {

    a {
      text-decoration: none;
      color: #385963;
      font-weight: 500;
      padding: 10px 0px;
      margin: 0 10px;
      position: relative;
      transition: color 0.4s;

      &:hover {
        color: #91abb3;
      }

      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 50%;
        background-color: #538392;
        transition: all 0.4s;
      }

      &:hover::before {
        width: 100%;
        left: 0;
      }

      &.active-tab {
        color: #91abb3;

        &::before {
          width: 100%;
          left: 0;
        }
      }
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

   
    @media (max-width: 1200px) {
      display: flex;
      align-items: center;
      a {
        font-size: 16px; 
        white-space: normal; 
        text-align: center; 
      }
    }
    @media (max-width: 992px) {
      a {
        font-size: 14px; 
        white-space: normal; 
        text-align: center; 
      }
    }
    @media (max-width: 768px) {
      a {
        font-size: 12px; 
        white-space: normal; 
        text-align: center;
         margin:0px;
      }
    }
    @media (max-width: 576px) {
      a {
        font-size: 10px; 
        white-space: normal; 
        text-align: center; 
         margin:0px;
      }
    }
  }
`;


const MainBody = styled.div`
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const ProfileMenuProvider = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const { state } = location;

  const [activeComponent, setActiveComponent] = useState(state?.activeComponent || 'crudProfile');

  useEffect(() => {
    if (state?.activeComponent) {
      setActiveComponent(state.activeComponent);
    }
  }, [state]);

  return (
    <>
      {/* <Header> */}
        <NavContainer>
          <NavTabs>
            <li>
              <Link
                to=""
                onClick={() => setActiveComponent('crudProfile')}
                style={{ fontWeight: activeComponent === 'crudProfile' ? 'bold' : 'normal' }}
              >
                {i18n.t('manageProfile')}
              </Link>
            </li>
            <li>
              <Link
                to=""
                onClick={() => setActiveComponent('businesses')}
                style={{ fontWeight: activeComponent === 'businesses' ? 'bold' : 'normal' }}
              >
                {i18n.t('amenities')}
              </Link>
            </li>
            <li>
              <Link
                to=""
                onClick={() => setActiveComponent('crudProviderEventRequest')}
                style={{ fontWeight: activeComponent === 'crudProviderEventRequest' ? 'bold' : 'normal' }}
              >
                {i18n.t('events')}
              </Link>
            </li>
          </NavTabs>
        </NavContainer>
      {/* </Header> */}

      <MainBody>
        {activeComponent === 'crudProfile' && <ProfileInfo />}
        {activeComponent === 'businesses' && <BusinessProviderControl />}
        {activeComponent === 'crudProviderEventRequest' && <EventProviderControl />}
      </MainBody>
    </>
  );
};

export default ProfileMenuProvider;
